import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { Team } from '../models/team';
import { map } from 'rxjs/operators';
import { TournamentTeam } from '../models/tournament-team';
import { TeamUser } from '../models/team-user';

@Injectable({providedIn: 'root'})
export class PublicTeamApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getById(teamId: number): Promise<Team> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/`).pipe(
      map(result => Team.toFront(result))
    ).toPromise();
  }

  getTournamentTeams(teamId: number, leagueId: number): Promise<TournamentTeam[]> {
    const params = new HttpParams().set('league_id', leagueId.toString());
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/tournament_teams/`, {params}).pipe(
      map(result => TournamentTeam.toFront(result))
    ).toPromise();
  }

  async getUsers(teamId: number): Promise<TeamUser[]> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/users/`)
      .pipe(map(data => TeamUser.toFront(data)))
      .toPromise();
  }
}
